import { openNotification } from 'Apps/VenueBuilder/helpers/openNotification';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function UploadImage(data) {
    try {
        let formData = new FormData();

        formData.append('projectId', data.projectId);
        for (let i = 0; i < data.files.length; i++) {
            formData.append(`files`, data.files[i]);
        }

    let url = `${process.env.REACT_APP_MYXP_API}/manager/livestream/upload`;
    if (data?.miniExperience) {
        url += '?miniExperience=1';
    }
    const response = await apiInterceptor(url, {
        method: 'POST',
        headers: {},
        body: formData,
    });

        const res = await response.json();

        if (res.success) {
            return data?.files?.length > 1 ? res.files : res.files[0];
        } else throw res;
    } catch (error) {
        openNotification('error', {
            message: error?.message || `Image upload failed: ${error}`,
        });
    }
}
